import { useEffect, useRef, useState } from 'react';
import { Button, Modal, Space } from 'antd';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { claimActionReminderPopups, markActionReminderPopupShown } from '../../../services/action-items.service';
import { formatJalaliDateTime } from '../../../utils/dateDisplay';

const POLL_MS = 45000;

export default function ActionItemReminderPopup() {
  const { user, activeOrganization, loading } = useAuth();
  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const shown = useRef(new Set());
  const userId = user?.id;

  useEffect(() => {
    if (loading || !userId) return undefined;
    let active = true;
    setItems([]);
    setOpen(false);
    setIndex(0);
    shown.current.clear();

    const load = async () => {
      try {
        const result = await claimActionReminderPopups();
        if (!active || !Array.isArray(result) || !result.length) return;
        setItems(result);
        setIndex(0);
        setOpen(true);
      } catch {
        /* Keep panel usable if reminders endpoint is unavailable. */
      }
    };

    const timer = setTimeout(load, 300);
    const poll = setInterval(load, POLL_MS);
    return () => {
      active = false;
      clearTimeout(timer);
      clearInterval(poll);
    };
  }, [userId, activeOrganization?.id, loading]);

  useEffect(() => {
    const item = items[index];
    if (!open || !item || shown.current.has(item.id)) return undefined;
    const timer = setTimeout(async () => {
      try {
        await markActionReminderPopupShown(item.id, item.token);
        shown.current.add(item.id);
      } catch {
        /* Remains eligible on a later entry if claim failed. */
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [items, index, open]);

  const current = items[index];
  const actionPath = current?.action_item_id ? `/action-items/${current.action_item_id}` : null;

  return (
    <Modal
      open={open}
      title="یادآوری اقدام"
      onCancel={() => setOpen(false)}
      footer={(
        <Space wrap>
          <Button onClick={() => setOpen(false)}>بستن</Button>
          {actionPath ? (
            <Link to={actionPath} onClick={() => setOpen(false)}>
              <Button type="primary" className="!border-0 !bg-brand-gradient">مشاهده اقدام</Button>
            </Link>
          ) : null}
          <span className="text-xs text-slate-500 dark:text-slate-400">{index + 1} از {items.length}</span>
          {index > 0 ? <Button onClick={() => setIndex((v) => v - 1)}>قبلی</Button> : null}
          {index < items.length - 1 ? <Button type="primary" onClick={() => setIndex((v) => v + 1)}>بعدی</Button> : null}
        </Space>
      )}
    >
      {current ? (
        <div className="space-y-2 text-right">
          <div className="text-base font-semibold text-slate-800 dark:text-slate-100">{current.action_title || 'اقدام'}</div>
          <p className="mb-0 text-sm text-slate-600 dark:text-slate-300">
            سررسید: {formatJalaliDateTime(current.due_at) || formatJalaliDateTime(current.remind_at) || '—'}
          </p>
        </div>
      ) : null}
    </Modal>
  );
}
